import { useEffect, useState } from 'react';
import { useDocReader } from '../store/docReaderContext';

// 获取PDF每一页的高度
export default function usePageHeights() {
    const [state] = useDocReader();
    const [pageViewHeights, setPageViewHeights] = useState<number[]>([]);
    useEffect(() => {
        const tempHeights: number[] = [];
        const getPageTasks: Promise<any>[] = [];
        Array.from({ length: state.totalPages }).forEach((_v, index) => {
            const task = state.pdf.getPage(index + 1);
            getPageTasks.push(task);
            task.then((page: any) => {
                const viewport = page.getViewport({ scale: 1 });
                tempHeights[index] = viewport.height;
            });
        });
        Promise.all(getPageTasks).then(() => {
            setPageViewHeights(tempHeights);
        });
    }, [state.pdf, state.totalPages]);
    return pageViewHeights;
}
